// <copyright file="apiconstant.ts" company="BD">
// Copyright (c) BD. All rights reserved.
// Created: 11/19/2025 by Sumanth Satheesh
// </copyright>

import { DeviceConfig } from "../../app/shared/model/devicetypemodel";

// Defines PACKAGEBYDEVICE_POST_APOLLO.
export const PACKAGEBYDEVICE_POST_APOLLO: DeviceConfig = {
  deviceType: "Apollo",
  sortBy: "Name",
  order: "ascending"
} as const;

// Defines PACKAGEBYDEVICE_POST_HEMOSPHEREALTA.
export const PACKAGEBYDEVICE_POST_HEMOSPHEREALTA: DeviceConfig = {
  deviceType: "HemoSphere Alta",
  sortBy: "Name",
  order: "ascending"
} as const;

// Defines fallbackApiVerion.
export const fallbackApiVerion = "v1";

export const webAppVersion = "Gateway/webappversion";

// Defines authorizationEndPoint.
export const authorizationEndPoint = {
  authLogin: "auth/login",
  authQueryParameterEmail: "?emailAddress=",
  authQueryClientType: "&clientType=web-app",
  generateCSRFToken: "auth/csrftoken",
  getTestCsrfToken: "CyberSecurity/get-test-csrf-token",
  customToken: "auth/custom-token",
};

export const userProfileEndPoint = {
  userProfileAndPermission: "administration/userprofile",
  roleList: "administration/roles"
};
